var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodeSignalSlowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5569_40345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 14.5C4.5 13.9477 4.94772 13.5 5.5 13.5H6.5C7.05228 13.5 7.5 13.9477 7.5 14.5V18.5C7.5 19.0523 7.05228 19.5 6.5 19.5H5.5C4.94772 19.5 4.5 19.0523 4.5 18.5V14.5Z",
    fill: "#D62222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10C10.5 9.44772 10.9477 9 11.5 9H12.5C13.0523 9 13.5 9.44772 13.5 10V18.5C13.5 19.0523 13.0523 19.5 12.5 19.5H11.5C10.9477 19.5 10.5 19.0523 10.5 18.5V10Z",
    fill: "#3C0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 5.5C16.5 4.94772 16.9477 4.5 17.5 4.5H18.5C19.0523 4.5 19.5 4.94772 19.5 5.5V18.5C19.5 19.0523 19.0523 19.5 18.5 19.5H17.5C16.9477 19.5 16.5 19.0523 16.5 18.5V5.5Z",
    fill: "#3C0A0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5569_40345"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeSignalSlowDark);
export default __webpack_public_path__ + "static/media/node-signal-slow-dark.4389d7d5c20087d80870a81bd9562a9d.svg";
export { ForwardRef as ReactComponent };